/* istanbul ignore file */
export enum FieldPointIconsSize {
    Small = 'small',
    Medium = 'medium'
}
